module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.145c35d9.svg";